<template>
    <div
        class="alertPill"
        :class="{'-expanded' : isExpanded}"
        @focus.capture="alertFocus(true)"
        @blur.capture="alertFocus(false)"
    >
        <button
            class="alertPill__header"
            :aria-expanded="isExpanded"
            tabindex="0"
            role="button"
            @click="toggle"
        >
            <div class="alertPill__icon">
                <svg v-if="type == 'alert'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.47 22">
                    <path d="M0,22H25.47L12.74,0,0,22Zm13.9-3.47h-2.32v-2.32h2.32v2.32Zm0-4.63h-2.32v-4.63h2.32v4.63Z" fill="#f36814"/>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                    <path d="M11,0C4.92,0,0,4.92,0,11s4.92,11,11,11,11-4.92,11-11h0C22,4.92,17.08,0,11,0Zm0,4.88c1.03,0,1.86,.83,1.86,1.86s-.83,1.86-1.86,1.86-1.86-.83-1.86-1.86h0c0-1.03,.83-1.86,1.86-1.86Zm2.48,11.27c0,.29-.24,.53-.53,.53h-3.9c-.29,0-.53-.24-.53-.53v-1.07c0-.29,.24-.53,.53-.53h.53v-2.84h-.54c-.29,0-.53-.24-.53-.53v-1.06c0-.29,.24-.53,.53-.53h2.84c.29,0,.53,.24,.53,.53v4.44h.53c.29,0,.53,.24,.53,.53v1.07Z" fill="#032e7e"/>
                </svg>
            </div>
            <div class="alertPill__title">
                {{ title }}
            </div>
            <div class="alertPill__trigger">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.5 7.5">
                    <path d="M1.25,1.25L6.25,6.25,11.25,1.25" fill="none" stroke="#032e7e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"/>
                </svg>
            </div>
        </button>
        <transition
            name="expand"
            @enter="startTransition"
            @leave="endTransition"
        >
            <div v-show="isExpanded" class="alertPill__wrapper">
                <div
                    class="alertPill__content flow"
                    v-html="message"
                />
                <div
                    v-if="cta"
                    class="alertPill__footer"
                >
                    <a :href="cta.url" :target="cta.target" class="alertPill__link">
                        <span>{{ cta.text }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16.181" height="10.8" viewBox="0 0 16.181 10.8">
                            <path d="M0,6.3H12.738L9.52,9.531,10.787,10.8l5.394-5.4L10.787,0,9.52,1.269,12.738,4.5H0Z" fill="#373e4e"/>
                        </svg>
                    </a>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { handleLinkClick } from '../../modules/external-links'
import { mapMutations } from 'vuex'

export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: false,
            default: 'alert',
        },
        id: {
            type: Number,
            required: true,
        },
        message: {
            type: String,
            required: false,
            default: '',
        },
        cta: {
            type: Object,
            required: false,
            default: null,
        },
        expand: {
            type: Boolean,
            required: false,
            default: false,
        },

    },

    data: () => ({
        isExpanded: false,
    }),

    mounted () {
        this.expand
            ? this.open()
            : this.close()

        document.querySelectorAll('.alertPill__wrapper a').forEach(link => {
            link.addEventListener('click', handleLinkClick)
        })
    },

    methods: {
        ...mapMutations({
            alertFocus: 'SET_ALERTS_FOCUS',
        }),

        toggle () {
            this.isExpanded ? this.close() : this.open()
            this.$emit('toggle-alert-pill', this.id)
        },

        open () {
            this.isExpanded = true
            this.$emit('open-alert-pill', this.id)
        },

        close () {
            this.isExpanded = false
        },

        startTransition (el) {
            el.style.height = el.scrollHeight + 'px'
        },
        endTransition (el) {
            el.style.height = 0
        },
    },

}
</script>
